import moment from "moment-timezone";
import { meetTimeFormat, meetTimeShortFormat } from "src/utils/constants";

export function getMeetTime(date: Date, forceMinutes = false) {
  const time = moment(date);

  let result = time.format(meetTimeFormat);

  if (time.minutes() === 0 && !forceMinutes) {
    result = time.format(meetTimeShortFormat);
  }

  return result;
}

export function processMeetTime(time: string) {
  let inputRaw: any = time.match(/\d/g);

  if (!inputRaw) {
    return;
  }

  inputRaw = inputRaw.join("");
  inputRaw = parseInt(inputRaw).toString();

  let newTime;

  if (inputRaw.length >= 6) {
    const minutes = inputRaw.slice(0, -4);
    const last4 = inputRaw.slice(-4);
    newTime = `${minutes}:${last4.slice(0, 2)}.${last4.slice(2)}`;
  } else if (inputRaw.length === 5) {
    newTime = `${inputRaw.slice(0, 1)}:${inputRaw.slice(1, 3)}.${inputRaw.slice(3)}`;
  } else if (inputRaw.length === 4) {
    newTime = `0:${inputRaw.slice(0, 1)}${inputRaw.slice(1, 2)}.${inputRaw.slice(2)}`;
  } else if (inputRaw.length === 3) {
    newTime = `0:0${inputRaw.slice(0, 1)}.${inputRaw.slice(1)}`;
  } else if (inputRaw.length === 2) {
    newTime = `0:00.${inputRaw}`;
  } else if (inputRaw.length === 1) {
    newTime = `0:00.0${inputRaw}`;
  } else {
    return;
  }

  return newTime;
}
